import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";

import Loading from "../Loading";

export default function Progress() {
  const [chartLoading, setChartLoading] = useState(true);
  const [chartData, setChartData] = useState("");

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          borderColor: "rgb(55, 55, 55)",
          tickColor: "rgb(55, 55, 55)",
        },

        ticks: {
          callback: function (value, index, values) {
            return value;
          },
          min: 0,
          max: 100,
          stepSize: 10,
        },
        title: {
          display: true,
          text: "Scores (in %)",
        },
        padding: 10,
      },
      x: {
        grid: {
          borderColor: "rgb(55, 55, 55)",
          tickColor: "rgb(55, 55, 55)",
        },

        title: {
          display: true,
          text: "Date",
        },
        ticks: {
          callback: function (val, index) {
            let date = new Date(parseInt(this.getLabelForValue(val)));
            let formattedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
            return formattedDate;
          },
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
          boxWidth: 20,
        },
        position: "bottom",
      },
    },
  };

  useEffect(() => {
    let labels = [];
    let data = {};
    let disposition_effect = [
      { x: "1630454400000", y: 33.333333329999995 },
      { x: "1633046400000", y: 50 },
      { x: "1635724800000", y: 20 },
    ];

    let overconfidence = [
      { x: "1630454400000", y: 40 },
      { x: "1633046400000", y: 20 },
      { x: "1635724800000", y: 100 },
    ];

    try {
      data = {
        labels: labels,
        datasets: [
          {
            label: "Disposition Effect",
            data: disposition_effect,
            //data: [20, 40, 55, 90, 60],
            fill: false,
            backgroundColor: "rgb(255, 99, 132)",
            borderColor: "rgba(255, 99, 132, 0.2)",
          },
          {
            label: "Overconfidence",
            data: overconfidence,
            //data: [40, 60, 40, 45, 80],
            fill: false,
            backgroundColor: "rgb(59, 93, 161)",
            borderColor: "rgba(59, 93, 161, 0.2)",
          },
        ],
      };
      setChartData(data);
      setChartLoading(false);
    } catch {
      setChartLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!chartLoading ? (
        <>
          <section className="progress-section">
            <div className="progress-container">
              <h1 className="report-header progress">
                <span> Progress</span>
              </h1>
              <figure className="progress-chart-container">
                <Line className="progress-chart" data={chartData} options={options} />
              </figure>
            </div>
          </section>
        </>
      ) : (
        <section className="progress-section" style={{ position: "relative", height: "500px" }}>
          <Loading inside={true} />
        </section>
      )}
    </>
  );
}
